export enum AppRoles {
  SUPER_ADMIN = 'ROLE_SUPER_ADMIN',
  LOCAL_FINANCE_ADMIN = 'ROLE_LOCAL_FINANCE_ADMIN',
  DISTRICT_FINANCE_ADMIN = 'ROLE_DISTRICT_FINANCE_ADMIN',
  AREA_FINANCE_ADMIN = 'ROLE_AREA_FINANCE_ADMIN',
  NATIONAL_FINANCE_ADMIN = 'ROLE_NATIONAL_FINANCE_ADMIN',
  MANAGER = 'ROLE_MANAGER'
}
